module.exports = __webpack_public_path__ + "img/img_example_1.d86a239a.png";